import { React, useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import Toast from '../actions/Toasts';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import apiService from '../../services/apiServices';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import InputController from '../../controllers/InputController';
import SelectController from '../../controllers/SelectController';
import SaveIcon from '@mui/icons-material/Save';

export default function ExtraHours(props) {
  const alert = { open: false, message: '', variant: '' };
  const [toast, setToast] = useState(alert);
  const [properties, setProperties] = useState(props);
  const [worker, setWorker] = useState();
  const [contract, setContract] = useState();
  const [totalPay, setTotalPay] = useState(0);
  //const [obj, setObj] = useState([]);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    setProperties(props);
    //setProperties({ open: false });
    //setObj(props.obj);
    if(props.id){
      getContracts(props.id)
    }
    // setValue('ExtraHours', props.item?.ExtraHours)
    // setValue('ExtraHoursWeekend', props.item?.ExtraHoursWeekend)
    // setValue('ExtraHoursHoliday', props.item?.ExtraHoursHoliday)
  }, [props]);

  useEffect(() => {
    setValue('ExtraHours', properties.item?.ExtraHours)
    setValue('ExtraHoursWeekend', properties.item?.ExtraHoursWeekend)
    setValue('ExtraHoursHoliday', properties.item?.ExtraHoursHoliday)
  }, [properties]);

  const handleClose = () => {
    setProperties({ open: false, id:0 });
    props.handleClose(false)
  };

  const getWorker = (id) => {
    apiService()
      .query('getWorker', 'id=' + id)
      .then((response) => {
        if(response.success && response.data.length > 0) {
          let w = response.data[0]
          setWorker(w)
          // setValue('Salary', w.BaseSalary ? w.BaseSalary : 0)
          // setValue('HourSalary', w.HourSalary ? w.HourSalary : 0)
        }
        else {
          // setValue('Salary', 0)
          // setValue('HourSalary', 0)
        }
    });
  }

  const getContracts = (id) => {
    apiService()
      .query('getWorkerContracts', 'id=' + id)
      .then((wc) => {
        if (wc.success) {
          let d = wc.data
          setContract(d[d.length - 1])
          setValue('HourSalary', d[d.length - 1]['HourSalary'])
          setValue('HourSalaryWeekend', d[d.length - 1]['HourSalaryWeekend'])
          setValue('HourSalaryHoliday', d[d.length - 1]['HourSalaryHoliday'])
        } else {
          console.log('Error1:' + wc.errorMessage);
        }
      });
  }

  const onValueChange = (param1, fieldName) => {
    let v = fieldName+'Value';
    // setValue(v, parseFloat(watch(fieldName))*parseFloat(contract ? contract[fieldName]: 1))
    //setValue(v, parseFloat(watch(fieldName)) * parseFloat(watch(param1)))
    let eh = watch('ExtraHours') ? parseFloat(watch('ExtraHours')) : 0
    let ehw = watch('ExtraHoursWeekend') ? parseFloat(watch('ExtraHoursWeekend')) : 0
    let ehh = watch('ExtraHoursHoliday') ? parseFloat(watch('ExtraHoursHoliday')) : 0

    //setTotalHours(eh + ehw + ehh)
    let val = parseFloat(watch('ExtraHours')) * parseFloat(watch('HourSalary')) + parseFloat(watch('ExtraHoursWeekend')) * parseFloat(watch('HourSalaryWeekend')) +parseFloat(watch('ExtraHoursHoliday')) * parseFloat(watch('HourSalaryHoliday'))
    
    setTotalPay(val)
    props.setHours(eh, ehw, ehh, properties.no, val)
  }
  const onValueChange1 = (param1, fieldName) => {}

  const calculateValue = (param1, fieldName) => {
    return (parseFloat(watch(fieldName)) * parseFloat(watch(param1)))
  }

  const save = () => {
    apiService()
      .put('workerContract', contract)
        .then((response) => {
          if (response.success) {
            setToast({
              open: true,
              message: 'U ruajten me sukses!',
              variant: 'success',
            });
          } else {
            setToast({
              open: true,
              message: 'Ka ndodhur nje gabim!',
              variant: 'error',
            });
          }
      });
  }

  return (
    <div style={{width: '70%'}}>
      <Toast {...toast} />
      <Dialog
        open={properties.open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">{properties.tittle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Card>
                <CardContent>
                    <form>
                        <Grid container spacing={3}>
                          <Grid container p={3} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item xs={4} sm={4} lg={4}>
                                <InputController
                                    placeholder="Ore shtese"
                                    // error={}
                                    control={control}
                                    type="number"
                                    fullWidth
                                    register={{ ...register('ExtraHours') }}
                                    onFieldChange={() => onValueChange('ExtraHours', 'HourSalary')}
                                />
                            </Grid>
                            <Grid item xs={4} sm={4} lg={4}>
                                <InputController
                                    placeholder="Paga per ore shtese"
                                    // error={}
                                    control={control}
                                    type="number"
                                    fullWidth
                                    register={{ ...register('HourSalary') }}
                                    onFieldChange={() => { onValueChange1('ExtraHours', 'HourSalary'); setContract({...contract, HourSalary: parseFloat(watch('HourSalary'))});}}
                                />
                            </Grid>
                            <Grid item xs={4} sm={4} lg={4}>
                                <InputController
                                    placeholder="Vlera"
                                    // error={}
                                    control={control}
                                    type="number"
                                    fullWidth
                                    symbol="€"
                                    disabled
                                    // register={{ ...register('HourSalaryValue') }}
                                    value={calculateValue('ExtraHours', 'HourSalary')}
                                />
                            </Grid>
                          </Grid>
                          <Grid container p={3} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item xs={4} sm={4} lg={4}>
                                <InputController
                                    placeholder="Ore shtese ditë fundjave"
                                    // error={}
                                    control={control}
                                    type="number"
                                    fullWidth
                                    register={{ ...register('ExtraHoursWeekend') }}
                                    onFieldChange={() => onValueChange('ExtraHoursWeekend', 'HourSalaryWeekend')}
                                />
                            </Grid>
                            <Grid item xs={4} sm={4} lg={4}>
                                <InputController
                                    placeholder="Paga per ore shtese ditë fundjave"
                                    // error={}
                                    control={control}
                                    type="number"
                                    fullWidth
                                    register={{ ...register('HourSalaryWeekend') }}
                                    onFieldChange={() => onValueChange('ExtraHoursWeekend', 'HourSalaryWeekend')}
                                />
                            </Grid>
                            <Grid item xs={4} sm={4} lg={4}>
                                <InputController
                                    placeholder="Vlera"
                                    // error={}
                                    control={control}
                                    type="number"
                                    fullWidth
                                    symbol="€"
                                    disabled
                                    // register={{ ...register('HourSalaryWeekendValue') }}
                                    value={calculateValue('ExtraHoursWeekend', 'HourSalaryWeekend')}
                                />
                            </Grid>
                          </Grid>
                          <Grid container p={3} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item xs={4} sm={4} lg={4}>
                                <InputController
                                    placeholder="Ore shtese ditë feste"
                                    // error={}
                                    control={control}
                                    type="number"
                                    fullWidth
                                    register={{ ...register('ExtraHoursHoliday') }}
                                    onFieldChange={() => onValueChange('ExtraHoursHoliday', 'HourSalaryHoliday')}
                                />
                            </Grid>
                            <Grid item xs={4} sm={4} lg={4}>
                                <InputController
                                    placeholder="Paga per ore shtese ditë feste"
                                    // error={}
                                    control={control}
                                    type="number"
                                    fullWidth
                                    register={{ ...register('HourSalaryHoliday') }}
                                    onFieldChange={() => onValueChange('ExtraHoursHoliday', 'HourSalaryHoliday')}
                                />
                            </Grid>
                            <Grid item xs={4} sm={4} lg={4}>
                                <InputController
                                    placeholder="Vlera"
                                    // error={}
                                    control={control}
                                    type="number"
                                    fullWidth
                                    symbol="€"
                                    disabled
                                    // register={{ ...register('HourSalaryHolidayValue') }}
                                    value={calculateValue('ExtraHoursHoliday', 'HourSalaryHoliday')}
                                />
                            </Grid>
                          </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Ok</Button>
          <Button onClick={() => save()} autoFocus>
            <SaveIcon />
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
